import { render, staticRenderFns } from "./WTMember.vue?vue&type=template&id=66248b28&scoped=true&"
import script from "./WTMember.vue?vue&type=script&lang=js&"
export * from "./WTMember.vue?vue&type=script&lang=js&"
import style0 from "./WTMember.vue?vue&type=style&index=0&id=66248b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66248b28",
  null
  
)

export default component.exports